import { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import Axios from 'axios';
import url from '../constants/urlsPaths';
import TestReviewContent from './TestReviewContent';

const getAuthToken = () => {
    const token = sessionStorage.getItem('token');
    if (!token || token === 'null' || token === 'undefined') {
        return null;
    }

    try {
        return JSON.parse(token);
    } catch (e) {
        return null;
    }
};

export default function TestReviewPage({ token }) {
    const [loading, setLoading] = useState(true);
    const [isAuthorized, setIsAuthorized] = useState(false);

    const cacheReviewPermissionsFromUsers = (users, code) => {
        const currentAdminUser = Array.isArray(users)
            ? users.find((u) => String(u?.code) === String(code))
            : null;

        const editLanguages = new Set();
        const translationLanguages = new Set();
        if (Array.isArray(currentAdminUser?.adminAuthorities?.edit?.languages)) {
            currentAdminUser.adminAuthorities.edit.languages.forEach((lang) => {
                editLanguages.add(String(lang).toLowerCase().trim());
            });
        }
        if (Array.isArray(currentAdminUser?.adminAuthorities?.uniqueEdit?.languages)) {
            currentAdminUser.adminAuthorities.uniqueEdit.languages.forEach((lang) => {
                editLanguages.add(String(lang).toLowerCase().trim());
            });
        }
        if (Array.isArray(currentAdminUser?.adminAuthorities?.translator?.pairs)) {
            currentAdminUser.adminAuthorities.translator.pairs.forEach((pair) => {
                if (pair?.from) translationLanguages.add(String(pair.from).toLowerCase().trim());
                if (pair?.to) translationLanguages.add(String(pair.to).toLowerCase().trim());
            });
        }

        if (currentAdminUser?.adminAuthorities) {
            sessionStorage.setItem('testReview_adminAuthorities', JSON.stringify(currentAdminUser.adminAuthorities));
        }
        sessionStorage.setItem('testReview_editLanguages', JSON.stringify(Array.from(editLanguages)));
        sessionStorage.setItem('testReview_translationLanguages', JSON.stringify(Array.from(translationLanguages)));
    };

    useEffect(() => {
        const authToken = getAuthToken();
        const code = sessionStorage.getItem('code');

        if (!token || !authToken || !code) {
            setIsAuthorized(false);
            setLoading(false);
            return;
        }

        Axios.post(
            url.survey,
            { code },
            { headers: { 'x-access-token': authToken } }
        )
            .then((res) => {
                const allowed = Boolean(res?.data?.auth) && String(res?.data?.type) === 'admin';
                if (!allowed) {
                    setIsAuthorized(false);
                    return null;
                }

                setIsAuthorized(true);
                return Axios.post(
                    url.allUsers,
                    { code },
                    { headers: { 'x-access-token': authToken } }
                );
            })
            .then((usersRes) => {
                if (usersRes?.data?.users) {
                    cacheReviewPermissionsFromUsers(usersRes.data.users, code);
                }
            })
            .catch(() => {
                setIsAuthorized(false);
            })
            .finally(() => {
                setLoading(false);
            });
    }, [token]);

    if (loading) {
        return (
            <div style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '18px'
            }}>
                Loading test review...
            </div>
        );
    }

    if (!isAuthorized) {
        return <Redirect to="/" />;
    }

    return <TestReviewContent token={token} />;
}
